module.exports = __webpack_public_path__ + "img/gold-medal.cb7f587e.svg";